/**
 * Examples based on property, depth, and parent:
 * - context0
 * - propertiesproductId1
 * - variantstype1
 */
export function getRowKey(property, depth, parent = '') {
  return `${parent}${property}${depth}`;
}

/**
 * Recursively gets all row keys from the properties and items objects
 */
export function getAllRowKeys(properties, depth, parent = '') {
  return Object.entries(properties).reduce((result, [property, values]) => {
    const key = getRowKey(property, depth, parent);
    result.push(key);

    if (values.properties) {
      result.push(...getAllRowKeys(values.properties, depth + 1, property));
    }

    if (values.items) {
      result.push(...getAllRowKeys(values.items, 1, property));
    }

    return result;
  }, []);
}
